import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../../components/Header/Header';
import icon from '../../../brand/generated/sidebar/cars.svg';
import HookForm from '../../../components/HookForm/HookForm';
import getComplectations from '../../../api/cars/getComplectations';
import SelectEngine from '../../../components/Selects/SelectEngine';
import SelectCarcase from '../../../components/Selects/SelectCarcase';
import editComplectation from '../../../api/cars/editComplectation';
import SelectWd from '../../../components/Selects/SelectWd';
import { textStyles } from '../../../constants/textStyles';
import LoaderInline from '../../../components/Loader/LoaderInline';
import alert from '../../../helpers/alert';
import styles from '../../../components/Inputs/Checkbox/checkbox.module.css';

const CheckboxField = ({ value, label, onChange }) => (
  <div className={styles.checkbox}>
    <input
      type="checkbox"
      id="restyling"
      checked={!!value}
      onChange={(e) => onChange(e.target.checked)}
    />
    <label htmlFor="restyling">{label}</label>
  </div>
);

const formStyles = {
  complectation: {
    display: 'grid',
    gap: '20px',
    gridTemplateColumns: '1fr 1fr 1fr',
  },
  equipments: {},
};

const additionalEquipments = Array.from({ length: 5 }, (_, index) => ({
  title: '',
  name: `equip-${index + 1}`,
}));

const CarComplectationsEdit = () => {
  const { containerId, complectationId } = useParams();

  const [complectation, setComplectation] = useState([]);
  const [safely, setSafely] = useState([]);
  const [equipments, setEquipments] = useState([]);
  const [removedFields, setRemovedFields] = useState(() => new Set());
  const removedFieldsRef = useRef(new Set());
  // ÐÐ¾Ð¼ÐµÑ Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð°Ð½Ð½ÑÑ â ÐºÐ»ÑÑ ÑÐ¾ÑÐ¼Ñ. ÐÐ¾Ð²ÑÐµ ÑÑÑÐ¾ÐºÐ¸ Ð²Ð²Ð¾Ð´ÑÑÑÑ Ð² Ð¿Ð¾Ð»Ñ Ð±ÐµÐ· id
  // (equipment_equip-N / comfort_equip-N). ÐÐ¾ÑÐ»Ðµ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ñ Ð¾Ð½Ð¸ Ð¿ÑÐ¸ÑÐ¾Ð´ÑÑ Ñ
  // ÑÐµÑÐ²ÐµÑÐ° ÑÐ¶Ðµ Ñ id Ð¸ Ð²ÑÑÐ°ÑÑ Ð² Ð¡ÐÐÐ Ð¿Ð¾Ð»Ñ, Ð½Ð¾ react-hook-form Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð°Ð»
  // Ð¿Ð¾Ð¼Ð½Ð¸ÑÑ ÑÐµÐºÑÑ Ð² ÑÑÐ°ÑÑÑ Ð¿Ð¾Ð»ÑÑ Ð±ÐµÐ· id â Ð¸ ÑÐ»ÐµÐ´ÑÑÑÐµÐµ Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑÂ» Ð¾ÑÐ¿ÑÐ°Ð²Ð»ÑÐ»Ð¾
  // ÑÐµ Ð¶Ðµ ÑÑÑÐ¾ÐºÐ¸ ÐºÐ°Ðº Ð½Ð¾Ð²ÑÐµ. ÐÑÐºÐµÐ½Ð´ ÑÐµÑÑÐ½Ð¾ Ð´Ð¾Ð±Ð°Ð²Ð»ÑÐ» Ð¸Ñ ÐµÑÑ ÑÐ°Ð·: Ñ Suburban Ð¿ÑÑÑ
  // ÑÑÑÐ¾Ðº Ð±ÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÐ¸ Ð¿ÑÐµÐ²ÑÐ°ÑÐ¸Ð»Ð¸ÑÑ Ð² Ð´ÐµÑÑÑÑ. Ð¡Ð¾ ÑÐ¼ÐµÐ½Ð¾Ð¹ ÐºÐ»ÑÑÐ° ÑÐ¾ÑÐ¼Ð°
  // Ð¿Ð¾Ð´Ð½Ð¸Ð¼Ð°ÐµÑÑÑ Ð·Ð°Ð½Ð¾Ð²Ð¾ Ð¸ Ð·Ð½Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ¾, ÑÑÐ¾ Ð²ÐµÑÐ½ÑÐ» ÑÐµÑÐ²ÐµÑ.
  const [formVersion, setFormVersion] = useState(0);

  const onRemoveField = (name) => {
    setRemovedFields((prev) => {
      const next = new Set(prev);
      next.add(name);
      removedFieldsRef.current = next;
      return next;
    });
  };

  const init = useCallback(() => {
    getComplectations({ containerId })?.then((res) => {
      const item = res?.data?.find((i) => +i?.id === +complectationId);
      const nextRemoved = new Set();
      removedFieldsRef.current = nextRemoved;
      setRemovedFields(nextRemoved);

      setComplectation([
        {
          name: 'title',
          label: 'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ',
          placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
          defaultValue: item?.title,
        },
        {
          name: 'engineId',
          label: 'Ð¢Ð¸Ð¿ ÑÐ¾Ð¿Ð»Ð¸Ð²Ð°',
          component: SelectEngine,
          placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
          defaultValue: { value: item?.engine.id, label: item?.engine.title },
        },
        {
          name: 'carcaseId',
          label: 'Ð¢Ð¸Ð¿ ÑÐ¾Ð¿Ð»Ð¸Ð²Ð°',
          component: SelectCarcase,
          placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
          defaultValue: { value: item?.carcase.id, label: item?.carcase.title },
        },
        {
          name: 'wdId',
          label: 'Ð¢Ð¸Ð¿ Ð¿ÑÐ¸Ð²Ð¾Ð´Ð°',
          component: SelectWd,
          placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
          defaultValue: { value: item?.wd.id, label: item?.wd.title },
        },
        {
          name: 'engine_volume',
          label: 'ÐÐ±ÑÐµÐ¼ Ð´Ð²Ð¸Ð³Ð°ÑÐµÐ»Ñ',
          placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
          defaultValue: item?.engine_volume,
        },
        {
          name: 'power_value',
          label: 'Ð.C.',
          defaultValue: item?.power_value,
        },
        {
          name: 'transmission',
          label: 'ÐÐ¾ÑÐ¾Ð±ÐºÐ° Ð¿ÐµÑÐµÐ´Ð°Ñ',
          defaultValue: item?.transmission,
        },
        {
          name: 'seats',
          label: 'ÐÐ¾Ð»Ð¸ÑÐµÑÑÐ²Ð¾ Ð¼ÐµÑÑ',
          defaultValue: item?.seats,
        },
        {
          name: 'generation',
          label: 'ÐÐ¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ðµ Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
          placeholder: 'Ð£ÐºÐ°Ð¶Ð¸ÑÐµ Ð¿Ð¾ÐºÐ¾Ð»ÐµÐ½Ð¸Ðµ',
          defaultValue: item?.generation,
        },
        {
          name: 'restyling',
          label: 'ÐÑÐ¸Ð·Ð½Ð°Ðº ÑÐµÑÑÐ°Ð¹Ð»Ð¸Ð½Ð³Ð° Ð¼Ð¾Ð´ÐµÐ»Ð¸ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
          component: CheckboxField,
          defaultValue: item?.restyling || false,
        },
        {
          name: '',
          component: () => <p style={textStyles.formTitle}>ÐÐ¾Ð¼ÑÐ¾ÑÑ Ð¸ ÐÐ±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ</p>,
          style: { gridColumn: '1 / span 3' },
        },
      ]);

      const equipmentInputs =
        [...(item?.complectation_equipment || []), ...additionalEquipments].map((equipment, index) => {
          const name = `equipment_${equipment.id || equipment.name}`;
          return {
            name,
          label: 'ÐÐ±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ ' + (index + 1),
          placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ Ð¾Ð±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ñ',
          defaultValue: equipment.title,
          style: { gridColumn: '1 / span 3' },
          removable: false,
          onRemove: onRemoveField,
            hide: () => removedFieldsRef.current.has(name),
          };
        });

      const safelyInputs =
        [...(item?.complectation_safely || []), ...additionalEquipments].map((equipment, index) => {
          const name = `comfort_${equipment.id || equipment.name}`;
          return {
            name,
          label: 'ÐÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÑ ' + (index + 1),
          placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð½Ð°Ð·Ð²Ð°Ð½Ð¸Ðµ',
          defaultValue: equipment.title,
          style: { gridColumn: '1 / span 3' },
          removable: false,
          onRemove: onRemoveField,
            hide: () => removedFieldsRef.current.has(name),
          };
        });

      setEquipments(equipmentInputs);
      setSafely(safelyInputs);
      setFormVersion((version) => version + 1);
    });
  }, [containerId, complectationId]);

  useEffect(() => {
    setComplectation([]);
    setEquipments([]);
    setSafely([]);
    init();
  }, [init]);


  const save = async (values) => {
    try {
      await editComplectation(complectationId, {
        title: values?.title,
        wdId: values?.wdId?.value,
        engineId: values?.engineId?.value,
        carcaseId: values?.carcaseId?.value,
        power_value: values?.power_value,
        engine_volume: values?.engine_volume,
        transmission: values?.transmission,
        seats: values?.seats,
        generation: values?.generation,
        restyling: values?.restyling || false,
        complectation_equipment: Object.keys(values)
          .filter((key) => key.startsWith('equipment_') && !removedFields.has(key) && String(values[key] || '').trim())
          .map((key) => ({
            id: +key.split('_')[1] || undefined,
            title: values[key],
          })),
        complectation_safely: Object.keys(values)
          .filter((key) => key.startsWith('comfort_') && !removedFields.has(key) && String(values[key] || '').trim())
          .map((key) => ({
            id: +key.split('_')[1] || undefined,
            title: values[key],
          })),
      });
      alert.success("ÐÐ°Ð½Ð½ÑÐµ ÑÑÐ¿ÐµÑÐ½Ð¾ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ñ");
      init();
    } catch(e) {
      alert.error(e);
    }
  };

  if (complectation?.length === 0) {
    return <LoaderInline />;
  }

  return (
    <>
      <Header title={'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ ' + complectationId} icon={icon} />
      <div style={{ paddingBottom: '20px', marginTop: 20 }}>
        <HookForm
          key={formVersion}
          title={'ÐÐ¾Ð¼Ð¿Ð»ÐµÐºÑÐ°ÑÐ¸Ñ'}
          grid={formStyles.complectation}
          border
          inputs={[
            ...complectation,
            ...equipments,
            {
              name: '',
              component: () => <p style={textStyles.formTitle}>ÐÐµÐ·Ð¾Ð¿Ð°ÑÐ½Ð¾ÑÑÑ</p>,
              style: { gridColumn: '1 / span 3' },
            },
            ...safely,
          ]}
          style={{ margin: 0 }}
          onSubmit={save}
          action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ'}
        />
      </div>
    </>
  );
};

export default CarComplectationsEdit;
